import React, { FunctionComponent, useState } from 'react';
import { Col, Row } from 'styled-bootstrap-grid';
import LazyloadBackgroundImage from 'view/components/content/LazyBackgroundImage';
import { ActionText, WatchItBox } from 'view/pages/about-us/components/Feature/styles';
import playButton from 'assets/images/employee-programs/play-button-large.png';
import MultilingualText from 'view/components/content/MultilingualText/MultilingualText';
import BannerVideoImg from 'assets/images/employee-programs/banner-video.png';
import Container from 'view/components/content/container';
import GTM from 'features/services';
import VideoModal from 'view/pages/about-us/components/VideoModal';
import { RowTitleVideoHappyParents, TitleVideoHappyParents, VideoHappy, PlayButtonHappy } from './styles';


export const VideoHappyParents: FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const youtubeVideoId = 'Pxufz8I_8Iw';
  const aboutUsFeatureHeader = <MultilingualText tKey="video-happy-parents-title" area="happy_parents" />;
  const onModalClose = () => {
    setIsModalOpen(false);
    setTags('happyParentsVideoExits');
  };
  const onModalOpen = () => {
    setIsModalOpen(true);
    setTags('happyParentsVideoEnters');
  };

  const setTags = (id) => {
    GTM(id, `https://www.youtube.com/watch?v=${ youtubeVideoId }`);
  };

  return <>
    <Container>
      <RowTitleVideoHappyParents>
        <TitleVideoHappyParents><MultilingualText tKey="video-happy-parents-title"
                                                  area="happy_parents" /></TitleVideoHappyParents>
      </RowTitleVideoHappyParents>

    </Container>
    <Container type="large">
      <Row>
        <Col col={ 12 } noGutter={ true }>
          <VideoModal GTMName={'happyParentsVideoPlays'}  youtubeVideoId={ youtubeVideoId } open={ isModalOpen } closeModal={ onModalClose }
                      header={ aboutUsFeatureHeader.toString() } />
          <LazyloadBackgroundImage image={ BannerVideoImg } width="100%" height="50rem">
            <VideoHappy backgroundImage={ BannerVideoImg } onMouseUp={ onModalOpen }>
              <WatchItBox>
                <PlayButtonHappy src={ playButton } />
                <ActionText><MultilingualText tKey="featureVideoButtonText" area="aboutUs" /></ActionText>
              </WatchItBox>
            </VideoHappy>
          </LazyloadBackgroundImage>
        </Col>
      </Row>
    </Container>
  </>;
};
